export default __webpack_public_path__ + "static/media/master-bg.d7b5886f.webp";